import React from "react";
import "./styles.css";
import TeamCard from "../UI/team-card";
import { teamArray } from "../../constants/contents";

function Team() {
  return (
    <div className="team">
      <h1>Nuestro equipo</h1>
      <div className="team__cards">
        {teamArray.map((teamCard) => (
          <TeamCard
            image={teamCard.image}
            role={teamCard.role}
            name={teamCard.name}
            link={teamCard.link}
          />
        ))}
      </div>
    </div>
  );
}

export default Team;
